import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { userSelector } from './selectors/user';
import type { StoredUser } from './types';
import { objValueNullToUndefined } from '../lib/utils';

const searchUserQueryName = 'searchUser';

/**
 * Provides query to search users based on provided query string.
 * Searches name and email address.
 * @param query query string for the search.
 * @returns custom hook that provides GraphQL query to search users.
 */
const useMatchedUsers = (
  query: string,
  onCompleted?: (d: readonly StoredUser[]) => void,
  onError?: (e: ApolloError) => void
) =>
  useTypedQuery(
    {
      search_user: [
        {
          args: { search: query },
        },
        userSelector,
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: {
        onCompleted: (data) => {
          if (onCompleted !== undefined) {
            const queriedUsers: readonly StoredUser[] = data.search_user
              .map((user) => objValueNullToUndefined<StoredUser>(user))
              .filter((user): user is StoredUser => user !== undefined);

            onCompleted(queriedUsers);
          }
        },
        onError,
      },
      operationOptions: {
        operationName: searchUserQueryName,
      },
    }
  );

export default useMatchedUsers;
